import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { Table, Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import { csvUrl, getData } from '../CustomUtils'
import ReportHeading from '../ReportHeading.js'
import ColumnHeadings from '../ColumnHeadings.js'
import { AAG_PLAINTIFF_UPDATE_REPORT_QUERY } from '../../../graphql.js'
import ParameterValues from '../ParameterValues.js'
import LargeRowHandler from '../LargeRowHandler.js'
import '../Custom.css'
import ReportGrid from '../ReportGrid.js'

const PLAINTIFF_UPDATE_REPORT = gql(AAG_PLAINTIFF_UPDATE_REPORT_QUERY)

export default function PlaintiffUpdate({ location }) {
  console.log('PlaintiffUpdate rendered')

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    getData(location, PLAINTIFF_UPDATE_REPORT, 'aagPlaintiffUpdate', setResults, setGraphQLErrors)
  }, [location])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    console.log(results)
    return (
      <div className="custom-scroll">
        <div style={{ textAlign: 'center', margin: '10px 0px' }}>
          <LargeRowHandler csvUrl={csvUrl('AAG/plaintiffUpdate/plaintiff_update', location)} resultsLength={results.reportData.length} />
        </div>
        <Table bordered style={{backgroundColor: 'white', width: 'auto', minWidth: '800px', margin: 'auto'}} >
          <ReportHeading title={'Plaintiff Update'} parameterValues={ParameterValues(results)} />
          <tbody>
            <ColumnHeadings results={results} />
            <ReportGrid results={results} viewButtonDataIndex={5} location={location} ignoreRowIndex={5} />
          </tbody>
        </Table>
      </div>
    )
  }
}